import EmptyStatesPreview from '../content/EmptyStatesPreview'
import LinkToTestResultsSteps from '../links/LinkToTestResultsSteps'
import { useAccess } from '@eggplant/routing'

const NoStepsIntro = () => {
  const [isAccessible] = useAccess()

  const description = isAccessible
    ? 'Add steps in your test case or scenario to see test run information of the steps here.'
    : ''

  return (
    <div className='grid h-full justify-center'>
      <div className='grid w-[36em]'>
        <EmptyStatesPreview
          description={description}
          icon={null}
          renderLink={
            isAccessible
              ? <LinkToTestResultsSteps />
              : null
          }
          title='No steps were executed'
        />
      </div>
    </div>
  )
}

export default NoStepsIntro
